import { Props } from './ClosedWonQueueLink'

import { Theme } from '@mui/material/styles'

export const getStyles = (props: Props, theme: Theme) => ({
  arrow: {
    marginLeft: theme.spacing(0.6),
  },

  link: {
    color: '#005aa3',
    cursor: 'pointer',
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: 14,
    marginRight: props.marginRight ?? theme.spacing(2.4),
  },
})
